export const getCadenceAnalyticsStepWise = {
  GET_CADENCE_ANALYTICS_STEPWISE_REQUEST: "GET_CADENCE_ANALYTICS_STEPWISE_REQUEST",
  GET_CADENCE_ANALYTICS_STEPWISE_SUCCESS: "GET_CADENCE_ANALYTICS_STEPWISE_SUCCESS",
  GET_CADENCE_ANALYTICS_STEPWISE_ERROR: "GET_CADENCE_ANALYTICS_STEPWISE_ERROR",
};
